import slick from "slick-carousel";
import circliful from "jquery-circliful";

window.onload = function () {

	const $slider = $(".results__slider");
	const $results = $(".results");
	const resultsOffset = $results.offset().top;
	let $sliderItems;
	const arrDasharraysDiagrams = [];


	// -- Scroll to up results BEGIN
	const scrollToUpResults = () => {
		const customOffset = 60;
		const fixedHeaderHeight = $(".header-scroll").outerHeight(true);
		const resultsSliderOffset = $results.find(".results__slider").offset().top;

		// -- Functions BEGIN
		const scrollToUp = () => {
			$("html, body").animate({
				scrollTop: resultsSliderOffset - fixedHeaderHeight - customOffset
			}, 800);
		};
		// -- Functions END

		scrollToUp();
	};
	// -- Scroll to up results END


	// Slider BEGIN
	const sliderInit = () => {
		const sliderOptions = {
			speed: 800,
			infinite: true,
			adaptiveHeight: true,
			prevArrow: $(".results__slider-arrow_prev"),
			nextArrow: $(".results__slider-arrow_next"),
			dots: true,
			appendDots: $(".results__slider-dots")
		};

		// -- Functions BEGIN
		$slider.on("init", function () {
			$sliderItems = $slider.find(".slick-slide");
		});

		$slider.on("beforeChange", function () {
			scrollToUpResults();

			function startAnimation () {
				const $curSlide = $slider.find(".slick-active");
				startDiagramAnimation($curSlide);
			}

			setTimeout(startAnimation, 50);
		});
		// -- Functions END

		$slider.slick(sliderOptions);
	};
	// Slider END


	// -- Diagrams initialization BEGIN
	const initDiagramItems = () => {

		// -- Functions BEGIN
		const initSingleDiagram = () => {
			$sliderItems.each(function () {
				const $curSlideDiagrams = $(this).find(".results__slider-item-diagram");
				const curSlideIndex = $(this).index();

				arrDasharraysDiagrams[`slide-${curSlideIndex}`] = {};
		
				$curSlideDiagrams.each(function () {
					const curForegroundColor = $(this).data("fgcolor");
					const curCustomText = $(this).data("custom-text");

					$(this).circliful({
						foregroundColor: curForegroundColor,
						foregroundBorderWidth: 7,
						backgroundBorderWidth: 1,
						replacePercentageByText: curCustomText,
						pointSize: 60,
						percentageY: 200
					});
				
					const $circle = $(this).find(".circle");
					const curDisgramIndex = $(this).index();
					const curDisgramDasharray = $circle.attr("stroke-dasharray");
					arrDasharraysDiagrams[`slide-${curSlideIndex}`][`diagram-${curDisgramIndex}`] = curDisgramDasharray;

					$circle.attr("stroke-dasharray", 0);
				});

			});
		};
		// -- Functions END

		if ($sliderItems.length) initSingleDiagram();
	};
	// -- Diagrams initialization END


	// -- Diagrams start BEGIN
	const startDiagramAnimation = ($element) => {
		const elementIndex = $element.index();
		const $elementDiagrams = $element.find(".results__slider-item-diagram");

		// -- Functions BEGIN
		const initAnimationSingleDiagram = () => {
			$elementDiagrams.each(function () {
				const indexCurDiagram = $(this).index();
				const dasharrayCurDiagram = arrDasharraysDiagrams[`slide-${elementIndex}`][`diagram-${indexCurDiagram}`];
				
				const $curCircle = $(this).find(".circle");
				if ($curCircle.length) {
					$curCircle.attr("stroke-dasharray", dasharrayCurDiagram);
				}
			});
		};
		// -- Functions END

		if ( $elementDiagrams.length ) initAnimationSingleDiagram();
	};
	// -- Diagrams start END


	// -- Scroll to results BEGIN
	const startDiagramWhenScrollResults = () => {
		const $activeSlide = $results.find(".slick-active").addClass("slide-diagram-init");
		const windowHeight = $(window).height() / 3 * 2;
		let curOffest = $(window).scrollTop();
		let flag = true;

		// -- Functions BEGIN
		const checkOffset = () => {
			curOffest = $(window).scrollTop() + windowHeight;

			if (curOffest >= resultsOffset) {
				flag = false;
				startDiagramAnimation($activeSlide);
			}
		};

		const setEventOnWindow = () => {
			document.addEventListener("scroll", function() {
				if (flag) checkOffset();
			}, {passive: true});
		};
		// -- Functions END 

		if ( $results.length ) setEventOnWindow();
		if (flag) checkOffset();
	};
	// -- Scroll to results END



	// -- Initialization BEGIN
	sliderInit();
	initDiagramItems();
	startDiagramWhenScrollResults();
	// -- Initialization END

};
